<template>
  <div class="over-table-pagination">
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number
    },
    formatter: {
      type: Function,
      default: (start, end, total) => `${start} - ${end} of ${total}`
    }
  },
  computed: {
    label() {
      const startValue = this.pageSize * (this.currentPage - 1) + 1
      const endValue = this.pageSize * this.currentPage
      const end = endValue > this.total ? this.total : endValue
      const start = startValue > end ? end : startValue
      return this.formatter(start, end, this.total)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.over-table-pagination {
  font-weight: 500;
  font-size: 14px;
  color: $black;
  text-align: right;
  width: 100%;
}
</style>
